import { getToken } from '@/utils/auth';
import { ElNotification } from 'element-plus';
import useNoticeStore from '@/store/modules/notice';

// // 初始化socket
// export const initWebSocket = (url: any) => {
//   if (import.meta.env.VITE_APP_WEBSOCKET === 'false') {
//     return;
//   }
//   url = url + '?Authorization=Bearer ' + getToken() + '&clientid=' + import.meta.env.VITE_APP_CLIENT_ID
//   // url = url + '?satoken=' + getToken()
//   useWebSocket(url, {
//     autoReconnect: {
//       // 重连最大次数
//       retries: 3,
//       // 重连间隔
//       delay: 10000,
//       onFailed() {
//         console.error('websocket重连失败');
//       },
//     },
//     // heartbeat: {
//     //   message: JSON.stringify({type: 'ping'}),
//     //   // 发送心跳的间隔
//     //   interval: 30000,
//     //   // 接收到心跳response的超时时间
//     //   pongTimeout: 2000,
//     // },
//     onConnected() {
//       console.log('websocket已经连接');
//     },
//     onDisconnected() {
//       console.log('websocket已经断开');
//     },
//     onMessage: (_, e) => {
//       console.log('接收到消息',_,e)
//       if (e.data.indexOf('ping') > 0) {
//         return;
//       }
//       console.log('接收到消息',_,e)
//       // useNoticeStore().addNotice({
//       //   message: e.data,
//       //   read: false,
//       //   time: new Date().toLocaleString()
//       // });
//       // ElNotification({
//       //   title: '消息',
//       //   message: e.data,
//       //   type: 'success',
//       //   duration: 3000
//       // });
//     }
//   });
// };

// 定义可选的配置项，方便后续扩展（例如传入不同的回调函数）
interface WsOptions {
  onMessage?: (data: any, e: MessageEvent) => void;
  onConnected?: () => void;
  onDisconnected?: () => void;
  onError?: (ws: WebSocket, event: Event) => void;
  // false 时关闭公共自动重连；控制权连接断开后必须由用户重新点击获取。
  autoReconnect?: boolean;
}

/**
 * 初始化 WebSocket
 * @param endpoint WebSocket 路径，例如 '/device/osd' 或 '/user/msg'
 * @param options 可选配置项，包含自定义消息处理回调等
 * @returns 返回 useWebSocket 实例，以便外部调用 send() 发送消息或 close() 关闭连接
 */
export const initWebSocket = (endpoint: string, options?: WsOptions) => {
  if (import.meta.env.VITE_APP_WEBSOCKET === 'false') {
    return null;
  }

  // 1. 在函数内部统一拼接 Base URL
  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  const host = window.location.host;
  const basePath = import.meta.env.VITE_APP_BASE_API || '';
  
  // 确保 endpoint 开头不漏掉 '/'
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // 使用 URL 解析 endpoint 自带的业务查询参数，避免 deviceSn 与鉴权参数之间出现多个问号。
  const url = new URL(`${protocol}${host}${basePath}/ws${cleanEndpoint}`);

  // 2. 拼接鉴权和客户端信息
  const token = getToken();
  const clientId = import.meta.env.VITE_APP_CLIENT_ID;
  url.searchParams.set('Authorization', `Bearer ${token}`);
  url.searchParams.set('clientid', clientId);

  // 3. 创建并返回 WebSocket 实例
  return useWebSocket(url.toString(), {
    autoReconnect: options?.autoReconnect === false ? false : {
      retries: 3,
      delay: 10000,
      onFailed() {
        console.error(`WebSocket [${cleanEndpoint}] 重连失败`);
      }
    },
    onError(ws, event) {
      console.error(`WebSocket [${cleanEndpoint}] 连接失败`);
      if (options?.onError) options.onError(ws, event);
    },
    onConnected() {
      console.log(`WebSocket [${cleanEndpoint}] 已经连接`);
      if (options?.onConnected) options.onConnected();
    },
    onDisconnected() {
      console.log(`WebSocket [${cleanEndpoint}] 已经断开`);
      if (options?.onDisconnected) options.onDisconnected();
    },
    onMessage: (data, e) => {
      // 过滤心跳包
      if (typeof e.data === 'string' && e.data.indexOf('ping') > 0) {
        return;
      }
      // 4. 如果调用方传入了自定义的消息处理逻辑，则执行调用方的逻辑
      if (options?.onMessage) {
        options.onMessage(data, e);
      } else {
        // 5. 否则执行默认的全局通知逻辑（按需解开注释）
        // useNoticeStore().addNotice({
        //   message: e.data,
        //   read: false,
        //   time: new Date().toLocaleString()
        // });
        // ElNotification({
        //   title: '系统消息',
        //   message: e.data,
        //   type: 'success',
        //   duration: 3000
        // });
      }
    }
  });
};
